<template>
  <div>
    <h1>Create New Exchange Rate</h1>
      <div class="box">
        <Errors/>
        <form class="form" v-on:submit.prevent="createExcahngeRate">
          <CurrencyExchangeRateFields />
          <div class="form-wrap form-submit">
            <div v-if="this.getLoadStatus">
              <button type="submit" class="button" disabled>Creating...</button>
            </div>
            <div v-else>
              <button type="submit" class="button">Create Exchange Rate</button>
            </div>
          </div>
        </form>
      </div>
  </div>
</template>
    
<script>
import CurrencyExchangeRateFields from '@/components/CurrencyExchangeRateFields.vue'
import Errors from '@/components/Errors.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ExchangeCreate',
  computed: mapGetters(['getLoadStatus']),
  data () {
    return {
      exchange_rate_from_fields: {
        flag: 'add',
      },
      errors: null
    }
  },
  components: {
    CurrencyExchangeRateFields,
    Errors
  },
  methods: {
    createExcahngeRate () {
        this.$store.dispatch('setLoadStatus')
        
        fetch(this.$api + 'currency-exchange/handle', {
            method: 'POST',
            body: JSON.stringify(this.exchange_rate_from_fields),
            headers:{
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': localStorage.getItem('token')
            }
        })
        .then(res => res.json())
        .then(response => {
            this.errors = response.errors
            if(response.status) {
                this.$router.push({ name: 'currency-exchange-index'})
                this.$notify({
                    type: 'success',
                    title: response.message
                });
            } else if (response.errors) {
                this.$notify({
                    type: 'error',
                    title: response.message
                });
            }
            this.$store.dispatch('setLoadStatus')
        });
    }
  }
}
</script>
    